export default "__VITE_ASSET__uLaPC82h__"